import { useState } from "react";
import Banner from "../components/Banner";
import { FAQ, FAQList, FAQItem } from "../components/FAQ";
import PaperformEmbed from "../components/PaperformEmbed";

export default function PageSponsorHub() {
  const [logoFile, setLogoFile] = useState(null);

  return (
    <>
      <Banner
        leftImage="img/bg-banner-round-gradient.webp"
        className="bg-white-after py-0"
      >
        <div className="col-12 col-lg-6 mb-4 mb-lg-0">
          <div className="display-1 color-white mb-3">FinComp Sponsor Hub</div>
          <p className="color-white mb-0">
            Everything you need to make the most of your sponsorship.
          </p>
        </div>

        <div className="col-12 col-lg-6">
          <img
            className="img-fluid rounded"
            src="../img/image-sponsorhub.webp"
            alt=""
          />
        </div>
      </Banner>

      <section className="bg-white" style={{ padding: "7em 0em" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-lg-6 mb-4 mb-lg-0">
              <h2 className="color-purple mb-3">Company logo</h2>
              <p>
                The assets you submit here will be used to represent your
                organization across FinComp materials, including the conference
                website, printed collateral, signage, and social media.
              </p>
              <p>
                Please submit a ZIP file containing two versions of your logo,
                each as a vector file (SVG, AI, EPS, or PDF) with a transparent
                background:
              </p>
              <ul>
                <li>Full color</li>
                <li>One-color (white or black)</li>
              </ul>
              <p className="mb-0">
                If a vector file is not available, a high-resolution PNG with a
                transparent background may be substituted for either version.
              </p>
            </div>

            <div className="col-12 col-lg-6">
              <div className="bg-light p-5 pb-2">
                <PaperformEmbed id="oukwjyjs" />

                {/*  <label htmlFor="companyLogoUpload" className="d-block mb-2">
                  Upload Company Logo
                </label>
                <label
                  htmlFor="companyLogoUpload"
                  className="d-flex align-items-center justify-content-center bg-white rounded"
                  style={{
                    height: "3.5rem",
                    cursor: "pointer",
                    textTransform: "uppercase",
                    fontSize: "0.85rem",
                    letterSpacing: "0.05em",
                  }}
                >
                  {logoFile ? logoFile : "Choose a file"}
                </label>
                <input
                  id="companyLogoUpload"
                  type="file"
                  accept=".zip"
                  className="d-none"
                  onChange={(e) =>
                    setLogoFile(e.target.files?.[0]?.name ?? null)
                  }
                /> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-light bg-rounded" style={{ padding: "7em 0em" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-lg-6 mb-4 mb-lg-0">
              <h2 className="color-purple mb-3">
                Before the conference: Promote your presence
              </h2>
              <p>
                We want to help you get the most out of your sponsorship before
                the conference even begins. To make this easy, we provide
                ready-to-use email and social media templates, along with
                branded graphics, so you can quickly let your network know you
                will be at FinComp.
              </p>
              <p>
                For Platinum sponsors, we also offer the opportunity to submit a
                custom social media post that we will share across our channels
                to highlight your presence.
              </p>
              <p className="fw-bold mb-2">What we provide:</p>
              <ul>
                <li>Sample social media posts</li>
                <li>Sample invitation email</li>
                <li>Branded social media graphics</li>
                <li>Branded email graphics</li>
              </ul>
              <p className="mb-0">
                If you are a Platinum sponsor, you can submit a custom social
                media post to{" "}
                <a href="mailto:fincomp@balancedcomp.com">
                  fincomp@balancedcomp.com
                </a>{" "}
                for us to share across FinComp channels. Submission deadline:{" "}
                <strong>Monday, May 10.</strong>
              </p>
            </div>

            <div className="col-12 col-lg-6 text-center">
              {/* TODO: swap for real sponsor social graphic */}
              <img
                className="img-fluid rounded mb-4"
                src="./img/graphic-fincomp-sponsor-toolkit.webp"
                alt="We are proud to be a sponsor"
                style={{ maxWidth: "500px" }}
              />
              <div>
                <a
                  href="../downloads/FinComp-2027-Sponsor-Toolkit.zip"
                  className="btn-red"
                  download
                >
                  Download Toolkit <i className="fa fa-download"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white" style={{ padding: "7em 0em" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-6 mb-4 mb-lg-0">
              <h2 className="color-purple mb-3">
                Built-in networking throughout the day
              </h2>
              <p>
                FinComp is designed to create consistent, high-quality
                opportunities to connect with attendees without forcing it.
              </p>
              <p>
                You are not waiting for networking opportunities to happen. They
                are built into the rhythm of the conference.
              </p>
            </div>

            <div className="col-12 col-lg-5 offset-lg-1">
              <div className="mb-3">
                <p className="fw-bold mb-1">Breakfast (7:30–8:30 AM)</p>
                <p>
                  A relaxed start to the day with strong attendance and early
                  conversations
                </p>
              </div>
              <div className="mb-3">
                <p className="fw-bold mb-1">Morning Break (9:00–9:15 AM)</p>
                <p>
                  A high-energy break with curated snacks and drinks that keep
                  attendees engaged and in the room
                </p>
              </div>
              <div className="mb-3">
                <p className="fw-bold mb-1">
                  Extended Lunch (11:45 AM–1:45 PM)
                </p>
                <p>
                  A full two-hour window designed for meaningful, unhurried
                  conversations
                </p>
              </div>
              <div className="mb-3">
                <p className="fw-bold mb-1">Afternoon Break (2:45 PM)</p>
                <p>
                  Another well-attended break with food and drinks that draws
                  people back into shared spaces
                </p>
              </div>
              <div className="mb-0">
                <p className="fw-bold mb-1">
                  Networking Mixer (Monday, 4:30–6:30 PM)
                </p>
                <p className="mb-0">
                  A dedicated event to kick off the conference with a more
                  social, high-engagement environment
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FAQ className="bg-light" style={{ padding: "7em 0em" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <h2 className="color-purple mb-3">Tradeshow Booth Information</h2>
              <p>
                We want the exhibit experience to feel straightforward and
                low-stress so you can focus on connecting with attendees
                throughout the conference. As additional details are finalized
                with the hotel, this page will continue to be updated with the
                latest information regarding setup, shipping, audiovisual
                support, and exhibit logistics.
              </p>
            </div>
          </div>
        </div>

        <FAQList>
          <FAQItem question="Where will the exhibits be located?">
            <p>
              Sponsor exhibits will be located within or directly adjacent to
              the primary conference session space to maximize attendee
              visibility and foot traffic throughout the event.
            </p>
            <p>
              Each sponsor exhibit space will be clearly identified upon
              arrival.
            </p>
            <p>
              Final room assignments and exhibit layouts will be shared once
              confirmed by the hotel.
            </p>
          </FAQItem>

          <FAQItem question="What is included with each exhibit space?">
            <p>Details to come.</p>
          </FAQItem>

          <FAQItem question="How do I ship exhibit materials to the hotel?">
            <p>Details to come.</p>
          </FAQItem>

          <FAQItem question="When can I set up and dismantle my exhibit?">
            <p>Details to come.</p>
          </FAQItem>

          <FAQItem question="How do I request power or audiovisual services?">
            <p>Details to come.</p>
          </FAQItem>

          <FAQItem question="Where can I store exhibit materials and equipment?">
            <p>Details to come.</p>
          </FAQItem>

          <FAQItem
            question={
              'When are the "open" times the exhibits need to be staffed?'
            }
          >
            <p>Details to come.</p>
          </FAQItem>
        </FAQList>
      </FAQ>

      <section className="bg-white" style={{ padding: "7em 0em" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-6 mb-4 mb-lg-0">
              <h2 className="color-purple mb-3">Speaking Opportunities</h2>
              <p>
                Gold and Platinum level sponsors are invited to participate in
                several opportunities to speak directly to our audience. FinComp
                attendees are HR and compensation professionals from banks and
                credit unions, so presentations that connect directly to their
                day-to-day challenges tend to land well.
              </p>
              <p className="mb-0">
                If your speaking opportunity includes a product presentation,
                please submit your PowerPoint file to{" "}
                <a href="mailto:fincomp@balancedcomp.com">
                  fincomp@balancedcomp.com
                </a>{" "}
                no later than <strong>Monday, May 10.</strong> This gives our
                team time to test and stage your file before the conference
                begins.
              </p>
            </div>

            <div className="col-12 col-lg-5 offset-lg-1">
              <p className="fw-bold mb-2">Platinum</p>
              <ul className="mb-4">
                <li>Invitation to speak on a pre-approved subject</li>
                <li>
                  2-minute company introduction during the lunch of your
                  choosing (extendable to 5 minutes when combined with a product
                  presentation)
                </li>
                <li>
                  Opportunity to facilitate one HR Roundtable Session alongside
                  a BalancedComp consultant
                </li>
                <li>
                  Opportunity to introduce a guest speaker at a general session
                  using a provided script
                </li>
              </ul>

              <p className="fw-bold mb-2">Gold</p>
              <ul className="mb-0">
                <li>
                  2-minute company introduction during the pre-conference
                  networking event
                </li>
                <li>
                  3-minute product presentation scheduled before or after a
                  general session
                </li>
                <li>
                  Opportunity to introduce a guest speaker at a general session
                  using a provided script
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Banner className="text-center" style={{ padding: "7em 0em" }}>
        <div className="col-12 col-lg-8 mx-auto">
          <div style={{ maxWidth: "45em", display: "inline-block" }}>
            <h2 className="color-white mb-3">
              Questions or Additional Support
            </h2>
            <p className="color-white mb-0">
              If you have questions leading up to the conference, our team is
              happy to help. Additional onsite contact information and event
              support details will be added closer to the conference date.
            </p>
          </div>
        </div>
      </Banner>
    </>
  );
}
